<template>
  <!-- 首页 -->
  <div class="box">
    <div class="img">
      <!-- <img class="img_bg" src="../../assets/background.png" alt="" /> -->
      <!-- <el-carousel
        trigger="click"
        ref="carousel"
        arrow="always"
        @mouseenter.native="delHandleMouseEnter()"
      >
        <el-carousel-item v-for="(item, index) in pic" :key="index">
          <img :src="item.src" alt="轮播图" class="img_bg" />
        </el-carousel-item>
      </el-carousel>-->

      <transition-group tag="div" name="fade">
        <img
          v-for="item in pic"
          :key="item.code"
          v-show="active == item.code"
          :src="item.src"
          class="img_bg"
          @click="btn(item.code)"
        />
      </transition-group>
      <!-- 轮播图小黑点点击切换 -->
      <div class="darkSpot">
        <span :class="active == 0 ? 'color' : ''" @click="darkSpot(0)"></span>
        <span :class="active == 1 ? 'color' : ''" @click="darkSpot(1)"></span>
        <span :class="active == 2 ? 'color' : ''" @click="darkSpot(2)"></span>
        <span :class="active == 3 ? 'color' : ''" @click="darkSpot(3)"></span>
      </div>
    </div>
    <div class="TheMainContent">
      <div class="centre">
        <div class="div1" id="div1">
          <div class="top">
            <span>产品中心</span>
            <br />PRODUCT CENTER
          </div>
          <div class="bottom">
            <div @click="div1Btn(1)">
              <!-- <router-link to="businessUnit"> -->
              <div>
                <img src="../../assets/images/home/system1.png" alt />
              </div>
              <div class="word">大气管理系统</div>
              <!-- </router-link> -->
            </div>
            <div @click="div1Btn(2)">
              <div>
                <img src="../../assets/images/home/system2.png" alt />
              </div>
              <div class="word">水专项系统</div>
            </div>
            <div @click="div1Btn(3)">
              <div>
                <img src="../../assets/images/home/system3.png" alt />
              </div>
              <div class="word">固废专项系统</div>
            </div>
            <div @click="div1Btn(4)">
              <div>
                <img src="../../assets/images/home/system4.png" alt />
              </div>
              <div class="word">指挥调度系统</div>
            </div>
            <div @click="div1Btn(5)">
              <div>
                <img src="../../assets/images/home/system5.png" alt />
              </div>
              <div class="word">智慧管网系统</div>
            </div>
            <div @click="div1Btn(6)">
              <div>
                <img src="../../assets/images/home/system6.png" alt />
              </div>
              <div class="word">电力专项系统</div>
            </div>
          </div>
        </div>
        <div class="div2" id="div2">
          <div class="top">
            <span>关于我们</span>
            <br />ABOUT US
          </div>
          <div class="bottom">
            <div>
              <!-- <img src="../../assets/images/home/information.png" alt="" /> -->
              <!-- <video
                width="100%"
                height="100%"
                src="http://49.4.68.154/video/智慧环保成品.mp4"
                preload="auto"
                webkit-playsinline="true"
                x5-video-player-type="h5"
                title="企业宣传视频"
                poster="../../assets/images/home/div1.png"
                controls
                controlslist="nodownload noremoteplayback noplaybackrate"
                disablePictureInPicture
              ></video>-->

              <video-player class="goods-video" ref="videoPlayer" :options="playerOptions"></video-player>
            </div>
            <div class="word">
              <div>北京中泽宇华环境科技有限公司成立于2018年，在北京、武汉建立研发中心，由具有丰富的环保从业经验和软件开发人员创建，致力于开发灵活、实用、高效、智能化的环保信息化管理系统。中泽宇华智慧环保系统历经多年升级迭代，先后在北京、江苏、湖南、湖北、山西等地成功应用，得到用户的一致好评。系统功能特点：我们将传统的人工现场检查，升级为数字化远程监控，系统融合污染源在线监测、用水、用能、环评、排污许可、应急预案、固危废、视频监控等多项环保数据，技术团队根据多年的环保管理经验，建立多维出数据分析模型，打破数据孤岛、通过对各类数据联动分析，自动诊断异常数据并进行预警报警，将传统的数据超标报警，扩展至环保手续不全、自行监测污染因子漏检、治理设施去除效率不达标、未“先开后停”、危废产转异常、超期储存、超量存储、未按要求执行停限产、污染物排放总量超标等自动预警报警。自动预警报警功能极大的提高环保管理的效率，通过预警报警——短信告知——现场检查或远程视频确认——事件处理——确认回复——销号，闭环管理流程，即使您是刚入行的环保从业者，也能进行精准的环保检查和服务，解决了人员少、专业知识匮乏的难点。PC端、移动端实时掌握环保管理现状、及时发现问题、及时整改，有效降低被问责、被处罚的风险系统可根据管理要求自动生产区域污染物因子库、各类污染物排放总量、企业排名、各企业管理现状、主要环境风险点等各类统计报表，有效减少查找资料和人员统计汇总时间，可节约50-70%。非现场执法、强化环保数据应用已在全国开始试点，在线化、无纸化管理势在必行，中泽宇华首创多维数据联动分析，更精准、更全面的环保管理，必将进一步降低换环保管理成本，提高环保管理效率，让环境管理部门、排污企业放心管理。中泽宇华，引领环保智慧管理新时代。</div>
              <el-button
                type="primary"
                round
                style="position: absolute; bottom: 0; right: 0"
                @click="div2Btn"
              >查看更多</el-button>
            </div>
          </div>
        </div>
        <div class="div3" id="div3">
          <div class="top">
            <span>行业新闻</span>
            <br />TRADE NEWS
          </div>
          <div class="bottom">
            <div class="word">
              <div @click="informationBtn(0)">
                <div class="pore"></div>环保企业如何在疫情常态化下找到发展机遇与动能？
              </div>
              <div @click="informationBtn(1)">
                <div class="pore"></div>如何精准精监控、降低环保处罚风险？园区环保信息化平台如何建？
              </div>
              <div @click="informationBtn(2)">
                <div class="pore"></div>“环保管家”如何帮政府和企业降低被问责和处罚风险？
              </div>
              <div @click="informationBtn(3)">
                <div class="pore"></div>生态部：关于印发《关于加强排污许可执法监管的指导意见》的通知
              </div>
            </div>
            <el-button
              type="primary"
              round
              style="position: absolute; bottom: 0; left: 0"
              @click="div3Btn"
            >查看更多</el-button>
            <div>
              <img src="../../assets/images/home/R-C.png" alt />
            </div>
          </div>
        </div>
        <div class="div4" id="div4">
          <div class="top">
            <span>合作伙伴</span>
            <br />COOPERATIVE PARTNER
          </div>
          <div class="bottom">
            <img src="../../assets/images/home/partner.png" alt />
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="btn" @click="consultingBtn()" v-show="on">
        <i class="el-icon-chat-line-round"></i>
        咨询我们
      </div>
    </transition>
    <transition name="fade">
      <div class="chat" v-show="show">
        <div class="top">
          咨询我们
          <i class="el-icon-close" @click="close()"></i>
          <i class="el-icon-minus" @click="minus()"></i>
        </div>
        <div class="bottom">
          <div class="chatting">
            <span>联系客服</span>
            <span>
              <el-input v-model="tel" label="label" size="small" type="tel" placeholder="请输入号码免费通话"></el-input>
            </span>
            <span>
              <el-button type="primary" size="small">提交</el-button>
            </span>
          </div>
          <div>
            <div class="news">
              <div class="left">
                <!-- <img
                  src="../../assets/images/home/head.png"
                  alt=""
                />-->
              </div>
              <div class="right">
                <div class="p">您好，请在上方填写您的联系方式，我们与您沟通需求；或者下方说出您的需求，稍后我们与您联系。</div>
              </div>
            </div>
          </div>
          <div class="inputBox">
            <el-input type="textarea" placeholder="请输入内容" v-model="inputBox" show-word-limit></el-input>
            <el-button type="primary" size="small" style="float: right; margin-bottom: 5px">发送</el-button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "",

  data() {
    return {
      scrollTop: null,
      //轮播图
      pic: [
        { src: require("../../assets/background03.png"), code: 0 },
        { src: require("../../assets/background04.png"), code: 1 },
        { src: require("../../assets/background05.png"), code: 2 },
        { src: require("../../assets/background06.png"), code: 3 }
      ],
      active: 0,
      //联系我们、
      show: false,
      on: true,
      tel: null,
      inputBox: null,
      // 视频参数
      playerOptions: {
        poster: require("../../assets/images/home/div1.png"),
        sources: [
          {
            type: "video/mp4", //视频格式
            src: "http://49.4.68.154/video/智慧环保成品.mp4" //视频地址
          }
        ]
      }
    };
  },

  created() {
    this.$store.state.menu = 1;
  },

  mounted() {
    // window.addEventListener("scroll", this.scroll);
    // this.$refs.carousel.handleMouseEnter = () => {};
    this.timer = setInterval(() => {
      this.time();
    }, 5000);
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },

  methods: {
    // 聊天框的弹出
    scroll() {
      let scrollTop = document.documentElement.scrollTop;
      if (scrollTop >= 900) {
        // this.show = true;
        // this.on = true;
      } else if (scrollTop < 900) {
        // this.show = false;
        // this.on = false;
      }
    },
    // 业务板块的跳转
    div1Btn(a) {
      this.$store.state.menu = 3;
      let num = null;
      switch (a) {
        case 1:
          num = "one";
          break;
        case 2:
          num = "two";
          break;
        case 3:
          num = "three";
          break;
        case 4:
          num = "four";
          break;
        case 5:
          num = "five";
          break;
        case 6:
          num = "six";
          break;
      }
      this.$router.push({ path: "/businessUnit", query: { id: num } });
    },
    div2Btn() {
      this.$store.state.menu = 2;
      this.$router.push({ path: "/aboutUs" });
    },
    div3Btn() {
      this.$store.state.menu = 4;
      this.$router.push({ path: "/dynamicInformation" });
    },
    // 鼠标移入卡片banner不停止
    // delHandleMouseEnter() {
    //   this.$refs.carousel.handleMouseEnter = () => {};
    // },
    // 显示关闭咨询我们页面
    consultingBtn() {
      this.on = false;
      this.show = !this.show;
    },
    // 关闭聊天框
    close() {
      // console.log(11111);
      this.show = false;
      this.on = false;
    },
    // 最小化聊天框
    minus() {
      this.show = false;
      this.on = true;
    },
    // 动态资讯详细页面跳转
    informationBtn(e) {
      // console.log(e);
      switch (e) {
        case 0:
          window.open(
            this.$router.resolve({ path: "/informationOne" }).href,
            "_blank"
          );
          break;
        case 1:
          window.open(
            this.$router.resolve({ path: "/informationTwo" }).href,
            "_blank"
          );
          break;
        case 2:
          window.open(
            this.$router.resolve({ path: "/informationThree" }).href,
            "_blank"
          );
          break;
        case 3:
          window.open(
            this.$router.resolve({ path: "/informationFour" }).href,
            "_blank"
          );
          break;
      }
    },
    time() {
      console.log("时间");
      this.active++;
      if (this.active > 3) {
        this.active = 0;
      }
    },
    //图片点击事件
    btn(code) {
      console.log("图片点击", code);
      if (code == 3) {
        this.$router.push({ path: "/businessUnit", query: { id: "seven" } });
      }
    },
    //小黑点点击事件
    darkSpot(e) {
      // console.log("小黑点点击");
      this.active = e;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.time();
      }, 5000);
    }
  },

  watch: {
    //监听路由是否变化
    $route(to, form) {
      console.log(to.query.id, form, "首页的跳转后");
      switch (to.query.id) {
        case "zero":
          console.log("首页");
          document.documentElement.scrollTop = 0;
          to.query.id = "zero";
          break;
        case "one":
          window.location.hash = "#div1";
          to.query.id = "zero";
          break;
        case "two":
          window.location.hash = "#div2";
          to.query.id = "zero";
          break;
        case "three":
          window.location.hash = "#div3";
          to.query.id = "zero";
          break;
        case "four":
          // window.location.hash = "#div4";
          this.$message({
            message: "在页面内哦",
            // type: "warning",
            duration: 1500
          });
          to.query.id = "zero";
          break;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100%;
  .img {
    position: relative;
    width: 100%;
    height: 33vw;
    padding-top: 100px;
    overflow: hidden;
    .img_bg {
      position: absolute;
      top: 100px;
      left: 0;
      width: 100%;
      height: 100%;
      animation: rotation 5s ease infinite;
    }
    .darkSpot {
      position: absolute;
      left: 50%;
      bottom: 50px;
      margin-left: -50px;
      display: flex;
      justify-content: space-around;
      width: 100px;
      height: 20px;
      span {
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 5px;
        cursor: pointer;
        background-color: rgb(255, 255, 255);
      }
      .color {
        background-color: rgb(96, 188, 241);
      }
    }
  }
  @-webkit-keyframes rotation {
    from {
      transform: scale(1.15, 1.15);
    }
    92% {
      // transform: scale(1, 1);
    }
    to {
      transform: scale(1, 1);
    }
  }
  .TheMainContent {
    max-width: 1200px;
    min-width: 900px;
    margin: auto;
    font-family: Microsoft YaHei;
    padding: 0 50px;
    .centre {
      display: flex;
      flex-direction: column;
      .div1 {
        width: 100%;
        color: #333;
        // margin-top: 70px;
        padding-top: 100px;
        .top {
          font-size: 16px;
          margin-bottom: 20px;
          span {
            font-size: 28px;
            line-height: 37px;
            padding-bottom: 15px;
          }
        }
        .bottom {
          display: flex;
          justify-content: space-evenly;
          text-align: center;
          > div {
            width: 15%;
            cursor: pointer;
            transition: 0.2s;
            -moz-transition: 0.2s; /* Firefox 4 */
            -webkit-transition: 0.2s; /* Safari 和 Chrome */
            -o-transition: 0.2s; /* Opera */
            img {
              width: 55%;
            }
            .word {
              font-size: 24px;
              color: #333333;
              font-family: Microsoft YaHei;
              padding-top: 20px;
              font-weight: 400;
              line-height: 31px;
              white-space: nowrap;
            }
          }
          > div:hover {
            margin-top: -5px;
            transition: 0.2s;
            -moz-transition: 0.2s; /* Firefox 4 */
            -webkit-transition: 0.2s; /* Safari 和 Chrome */
            -o-transition: 0.2s; /* Opera */
          }
        }
      }
      .div2 {
        width: 100%;
        // margin-top: 70px;
        padding-top: 100px;
        color: #333;
        .top {
          font-size: 16px;
          margin-bottom: 10px;
          span {
            font-size: 28px;
            line-height: 37px;
            padding-bottom: 15px;
          }
        }
        .bottom {
          display: flex;
          height: 30vh;
          > div:nth-child(1) {
            position: relative;
            width: 40%;
            height: 100%;
            overflow: hidden;
            // 视频的具体参数
            /deep/ #vjs_video_3 {
              width: 100%;
              height: 100%;
            }
            /deep/ .video-js {
              width: 110%;
              height: 100%;
            }
            .goods-video {
              height: 100%;
              width: 100%;
              .video-js {
                width: 100%;
                height: 100%;
              }
              /deep/ .video-js .vjs-big-play-button {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 42px;
                height: 42px;
                border-radius: 21px;
                background-color: rgba(255, 255, 255, 0.2);
                border: 0px;
              }
              /deep/ .video-js .vjs-big-play-button {
                line-height: 38px !important;
              }
              // /deep/ .vjs-control-bar {
              //   display: none;
              // }
              /deep/ .vjs-icon-placeholder::after {
                background-color: rgba(255, 255, 255, 0.8) !important;
              }
            }
          }

          // div:nth-child(1) {
          //   width: 40%;
          //   height: 100%;
          //   overflow: hidden;
          //   img {
          //      width: 100%;
          //   height: 100%;
          //     transition: 1.2s;
          //     -moz-transition: 1.2s; /* Firefox 4 */
          //     -webkit-transition: 1.2s; /* Safari 和 Chrome */
          //     -o-transition: 1.2s; /* Opera */
          //   }
          // }
          // div:nth-child(1):hover {
          //   width: 40%;
          //   height: 100%;
          //   overflow: hidden;
          //   img {
          //     width: 110%;
          //     height: 110%;
          //     margin-left: -5%;
          //     margin-top: -5%;
          //     margin-bottom: -10%;
          //     transition: 1.2s;
          //     -moz-transition: 1.2s; /* Firefox 4 */
          //     -webkit-transition: 1.2s; /* Safari 和 Chrome */
          //     -o-transition: 1.2s; /* Opera */
          //   }
          // }.
          .word {
            width: 60%;
            height: 100%;
            font-size: 16px;
            line-height: 1.5;
            text-indent: 2em;
            padding-left: 50px;
            position: relative;
            color: #666;
            div:nth-child(1) {
              width: 100%;
              text-align: justify;
              // height: 80%;
              // overflow: auto;
              // &::-webkit-scrollbar {
              //   display: none; /*隐藏滚动条*/
              // }
              @media only screen and (min-width: 1920px) {
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 9;
                -webkit-box-orient: vertical;
              }
              @media only screen and (max-width: 1919px) and (min-width: 1200px) {
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 7;
                -webkit-box-orient: vertical;
              }
              @media only screen and (max-width: 1199px) {
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 7;
                -webkit-box-orient: vertical;
              }
              // overflow: hidden;
              // display: -webkit-box;
              // -webkit-line-clamp: 9;
              // -webkit-box-orient: vertical;
            }
          }
        }
      }
      .div3 {
        color: #333;
        width: 100%;
        // margin-top: 70px;
        padding-top: 100px;
        .top {
          font-size: 16px;
          margin-bottom: 10px;
          span {
            font-size: 28px;
            line-height: 37px;
            padding-bottom: 15px;
          }
        }
        .bottom {
          position: relative;
          display: flex;
          height: 30vh;
          .word {
            width: 60%;
            height: 100%;
            padding-right: 50px;
            display: flex;
            flex-direction: column;
            div {
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis; //溢出用省略号显示
              white-space: nowrap; //溢出则不换行
              height: 20%;
              transition: all 0.5s;
              -moz-transition: 0.5s; /* Firefox 4 */
              -webkit-transition: 0.5s; /* Safari 和 Chrome */
              -o-transition: 0.5s; /* Opera */
              cursor: pointer;
            }
            .pore {
              display: block;
              width: 6px;
              height: 6px;
              margin-bottom: 5px;
              background-color: #000;
              transition: all 0.5s;
              -moz-transition: 0.5s; /* Firefox 4 */
              -webkit-transition: 0.5s; /* Safari 和 Chrome */
              -o-transition: 0.5s; /* Opera */
            }
            > div:hover {
              color: #66b1ff;
              transition: all 0.5s;
              -moz-transition: 0.5s; /* Firefox 4 */
              -webkit-transition: 0.5s; /* Safari 和 Chrome */
              -o-transition: 0.5s; /* Opera */
              .pore {
                width: 30px;
                background-color: #66b1ff;
                transition: all 0.5s;
                -moz-transition: 0.5s; /* Firefox 4 */
                -webkit-transition: 0.5s; /* Safari 和 Chrome */
                -o-transition: 0.5s; /* Opera */
              }
            }
          }
          > div:nth-child(3) {
            width: 40%;
            height: 100%;
            overflow: hidden;
            img {
              transition: 1.2s;
              -moz-transition: 1.2s; /* Firefox 4 */
              -webkit-transition: 1.2s; /* Safari 和 Chrome */
              -o-transition: 1.2s; /* Opera */
            }
          }
          > div:nth-child(3):hover {
            width: 40%;
            height: 100%;
            overflow: hidden;
            background-color: rgb(219, 107, 107);
            img {
              width: 110%;
              height: 110%;
              margin-left: -5%;
              margin-top: -5%;
              margin-bottom: -10%;
              transition: 1.2s;
              -moz-transition: 1.2s; /* Firefox 4 */
              -webkit-transition: 1.2s; /* Safari 和 Chrome */
              -o-transition: 1.2s; /* Opera */
            }
          }
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .div4 {
        width: 100%;
        // margin-top: 70px;
        // margin-bottom: 70px;
        padding: 100px 0;
        color: #333;
        .top {
          font-size: 16px;
          margin-bottom: 10px;
          span {
            font-size: 28px;
            line-height: 37px;
            padding-bottom: 15px;
          }
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
      .top {
        height: 60px;
      }
      span {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 37px;
        color: #333333;
      }
    }
  }
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    right: 0;
    bottom: 244px;
    width: 40px;
    height: 175px;
    font-size: 20px;
    color: #008cd7;
    writing-mode: tb-rl;
    line-height: 1.5;
    letter-spacing: 6px;
    cursor: pointer;
    user-select: none;
    background: rgba(255, 255, 255, 0.7);
    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.16);
    border-radius: 16px;
    z-index: 2;
    i {
      font-size: 30px;
    }
  }
  .chat {
    position: fixed;
    bottom: 10px;
    right: 0px;
    width: 334px;
    height: 419px;
    border-radius: 16px;
    background: #f6f6f6;
    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.16);
    z-index: 2;
    // border: 1px solid #000;
    overflow: hidden;
    .top {
      position: relative;
      width: 100%;
      height: 46px;
      color: #fff;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      line-height: 46px;
      border-radius: 16px 16px 0 0;
      background-color: #0064a1;
      i {
        position: absolute;
        top: 0;
        right: 0;
        line-height: 46px;
        padding-right: 5px;
        font-size: 20px;
        cursor: pointer;
      }
      :nth-child(2) {
        position: absolute;
        top: 0;
        right: 25px;
      }
    }
    .bottom {
      width: 100%;
      height: calc(100% - 46px);
      .chatting {
        width: 100%;
        height: 46px;
        background: #eeeeee;
        display: flex;
        justify-content: space-evenly;
        white-space: nowrap;
        line-height: 46px;
        font-size: 16px;
        color: #666;
        /deep/.el-input {
          width: 160px !important;
          margin: 0 10px;
        }
      }
      > div:nth-child(2) {
        height: 242px;
        overflow: auto;
        padding: 10px;
        color: #333;
        box-sizing: border-box;
        .news {
          display: flex;
          height: 80px;
          font-size: 12px;
          .left {
            width: 40px;
            height: 40px;
            border-radius: 20px;
            overflow: hidden;
            background-color: #fff;
            background-image: url("../../assets/images/home/head.png");
            background-size: 30px 30px;
            background-repeat: no-repeat;
            background-position: 5px;
          }
          .right {
            position: relative;
            width: 220px;
            height: 100%;
            margin-top: 20px;
            margin: 10px;
            border-radius: 12px;
            background: rgba(255, 255, 255, 0.39);
            box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.16);
            ::after {
              content: "";
              position: absolute;
              top: 0;
              left: -20px;
              width: 0px;
              height: 0px;
              border: 10px solid;
              border-color: transparent #f9f9f9 transparent transparent;
              background-color: transparent;
            }
            .p {
              padding: 10px;
            }
          }
        }
      }
      .inputBox {
        height: 85px;
        background: #ffffff;
        padding: 0 10px 10px 10px;
        /deep/.el-textarea__inner {
          padding: 0;
          border: 0px solid #000;
        }
      }
    }
  }
  a {
    text-decoration: none;
  }
  .router-link-active {
    text-decoration: none;
  }

  // 轮播图样式
  /deep/ .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
    width: 100%;
    height: 100%;
  }
  /deep/.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  /deep/.el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
  }
  /deep/ .el-carousel--horizontal {
    height: 100% !important;
  }
  /deep/.el-carousel__container {
    height: 100% !important;
  }

  // 咨询我们过渡效果
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 1s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0;
  }
}
</style>
